module.exports = [{
      plugin: require('/Users/markgituma/Desktop/GITHUB/kubecon2018jobs/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/markgituma/Desktop/GITHUB/kubecon2018jobs/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-131111082-1"},
    }]
